import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export interface Page {
  id: string;
  page_type: string;
  content_en: string;
  content_fr: string;
  created_at: string;
}

interface AdminPagesResponse {
  pages: Page[];
}

interface GetPagesParams {
  limit?: number;
  offset?: number;
  status?: string;
}

export const getPages = async (params?: GetPagesParams): Promise<AdminPagesResponse> => {
  return (apiClient as any).get('/api/admin/pages', { params });
};

export const useGetPagesQuery = (params?: GetPagesParams) => {
  return useQuery({
    queryKey: queryKeys.pages.list(params),
    queryFn: () => getPages(params),
    select: data => data.pages || [],
  });
};
